import { PostmessageExternalSender } from '../_utils';

const post = new PostmessageExternalSender();

export const usePostMessageApi = () => {
  return {
    keepAlive: () => post.keepAlive(),
    openUrl: (url: string) => post.openUrl(url),
    sendEmail: (email: string) => post.sendEmail(email),
  };
};
